import React, { useState } from 'react';
import AssignDriverDialog from './dialog/AssignDriverDialog';
import { useTranslation } from 'react-i18next';

const AssignedDriver: React.FC = () => {
  const { t } = useTranslation('client');
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);

  const openDialog = () => {
    setIsAddDialogOpen(true);
  };

  const closeDialog = () => {
    setIsAddDialogOpen(false);
  };

  const handleDialog = async () => {
    openDialog();
  };

  return (
    <>
      <button type="button"
        onClick={() => handleDialog()}
        className="bg-primary/50 text-primary/300 rounded-md px-5 py-2"
      >
        {t('graph.assign_driver')}
      </button>
      <AssignDriverDialog isOpen={isAddDialogOpen} onClose={closeDialog} />
    </>
  );
};
export default AssignedDriver;
